#import "./cartFragment.gql"

mutation addDiscountCodeMutation($id: ID!, $discountCodes: [String!]!, $lang: LanguageCode!)
@inContext(language: $lang) {
  cartDiscountCodesUpdate(cartId: $id, discountCodes: $discountCodes) {
    cart {
      ...cartFragment
    }
    userErrors {
      field
      message
    }
  }
}
